/* eslint-disable no-console */
import _ from 'underscore';
import { getItemsFromAccount } from '../consumer-account/storage-actions';
import { updateAssetUrlDimensions } from '../widen-utils';

_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g,
};

const sceneSelectionTemplate =
  `<div class="col">
    <div class="saved-asset-card">
      <div class="form-group">
        <div class="form-label">
          <img class="saved-asset-image" src="{{ thumbnailUrl }}" alt="" />
          <input type="checkbox" id="saved-product-{{ assetId }}" name="saved-product-{{ assetId }}" value='{"product-name":"{{ tileName }}","color-name":"{{ color }}","window-width":"{{ windowWidth }}","window-height":"{{ windowHeight }}","notes":"{{ notes }}"}' data-drip="selected_product_info" />
          <label for="saved-product-{{ assetId }}" class="checkbox-label body-sm mt-3">{{ tileName }}, {{ color }}</label>
        </div>
      </div>
    </div>
  </div>`;

const sceneSelectionTemplateVals = _.template(sceneSelectionTemplate);

const appendSavedProducts = (data, form) => {
  const selector = form.querySelector('.saved-products-row');
  data.forEach((item) => {
    item.assetId = item['product-id'];
    item.color = item.color;
    item.notes = item.notes;
    item.tileName = item['tile-name'].replace(/"|&quot;/gi, '″');
    item.thumbnailUrl = updateAssetUrlDimensions({
      src: item['widen-url'],
      width: 100,
      height: 100,
    });
    item.windowHeight = item['window-height'];
    item.windowWidth = item['window-width'];
    const compiled = sceneSelectionTemplateVals(item);
    const div = document.createElement('div');
    div.innerHTML = compiled;
    selector.appendChild(div.firstChild);
  });
};

const addProductsFormGroup = (form) => {
  const { isAuthenticated } = window;
  if (!isAuthenticated) {
    return;
  }
  // Always make sure we have the most recent updates...
  getItemsFromAccount('product', (data) => {
    if (data.products.length === 0) {
      return;
    }
    appendSavedProducts(data.products, form);
  });
};

export {
  addProductsFormGroup,
  appendSavedProducts,
};
/* eslint-enable no-console */
